import { Component } from '@angular/core';
import { FormsModule, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgIf } from '@angular/common';
import { AuthService } from '../../services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoggerService } from '../../core/services/logger.service';
import { homeRouteFor } from '../../guards/transportista-allowlist';

@Component({
    selector: 'app-sign-in',
    imports: [MatButton, MatIconButton, FormsModule, MatFormFieldModule, MatInputModule, MatCheckboxModule, ReactiveFormsModule, NgIf, MatProgressSpinnerModule],
    templateUrl: './sign-in.component.html',
    styleUrl: './sign-in.component.scss'
})
export class SignInComponent {

    constructor(
        // eslint-disable-next-line no-unused-vars
        private formBuilder: FormBuilder,
        // eslint-disable-next-line no-unused-vars
        private router: Router,
        // eslint-disable-next-line no-unused-vars
        private authService: AuthService,
        // eslint-disable-next-line no-unused-vars
        private snackBar: MatSnackBar,
        // eslint-disable-next-line no-unused-vars
        private logger: LoggerService
    ) {
        // Cargar email guardado si existe
        const savedEmail = this.getSavedEmail();
        
        this.authForm = this.formBuilder.group({
            email: [savedEmail || '', [Validators.required, Validators.email]],
            password: ['', [Validators.required, Validators.minLength(8)]],
            rememberMe: [!!savedEmail], // Marcar como true si hay email guardado
        });
    }

    // Password Hide
    hide = true;

    // Form
    authForm: FormGroup;
    isLoading = false;

    onSubmit() {
        if (this.authForm.valid) {
            this.isLoading = true;
            
            const formValue = this.authForm.value;
            const rememberMe = formValue.rememberMe;
            
            // Guardar o eliminar email según el estado del checkbox
            if (rememberMe) {
                this.saveEmail(formValue.email);
            } else {
                this.clearSavedEmail();
            }
            
            // Preparar datos para login (sin rememberMe)
            const loginData = {
                email: formValue.email,
                password: formValue.password
            };
            
            this.authService.login(loginData).subscribe({
                next: () => {
                    this.isLoading = false;
                    this.snackBar.open('Inicio de sesión exitoso', 'Cerrar', {
                        duration: 3000,
                        horizontalPosition: 'center',
                        verticalPosition: 'top',
                    });
                    const landingRoute = this.authService.hasRole('consignatario')
                        ? '/control-dus'
                        : homeRouteFor(this.authService);
                    this.router.navigate([landingRoute]);
                },
                error: (error) => {
                    this.isLoading = false;
                    this.logger.error('Error de login', error as Error, 'SignInComponent');
                    
                    let errorMessage = 'Error al iniciar sesión';
                    
                    if (error.status === 401) {
                        // Extraer el mensaje específico del backend si está disponible
                        if (error.error && error.error.message) {
                            errorMessage = error.error.message;
                        } else {
                            errorMessage = 'Credenciales inválidas';
                        }
                    } else if (error.status === 0) {
                        errorMessage = 'No se puede conectar con el servidor';
                    }
                    
                    this.snackBar.open(errorMessage, 'Cerrar', {
                        duration: 5000,
                        horizontalPosition: 'center',
                        verticalPosition: 'top',
                    });
                }
            });
        } else {
            this.logger.warn('Formulario inválido, verificar campos', 'SignInComponent');
        }
    }

    /**
     * Guarda el email en localStorage para recordar al usuario
     */
    private saveEmail(email: string): void {
        if (typeof window !== 'undefined') {
            localStorage.setItem('remembered_email', email);
        }
    }

    /**
     * Obtiene el email guardado de localStorage
     */
    private getSavedEmail(): string | null {
        if (typeof window !== 'undefined') {
            return localStorage.getItem('remembered_email');
        }
        return null;
    }

    /**
     * Elimina el email guardado de localStorage
     */
    private clearSavedEmail(): void {
        if (typeof window !== 'undefined') {
            localStorage.removeItem('remembered_email');
        }
    }

}